import { styled } from '@mui/material/styles';
import { colors } from 'theme/colors';

export const MobileCategoryCard = styled('div')({
  backgroundColor: colors.white,
  overflow: 'hidden',
});

export const MobileCategoryHeader = styled('div')({
  backgroundColor: colors.primary25,
  padding: '6px 12px',
  height: '32px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid ${colors.primary50}`,
  userSelect: 'none',
});

export const MobileCategoryTitle = styled('div')({
  fontSize: '14px',
  fontWeight: 600,
  color: colors.gray900,
  display: 'flex',
  alignItems: 'center',
  lineHeight: '20px',
  margin: 'auto',
});

export const MobileNoChangesText = styled('div')({
  padding: '16px',
  textAlign: 'center',
  color: colors.gray900,
  fontStyle: 'italic',
  fontSize: '14px',
});

export const MobileFieldCard = styled('div')({
  borderBottom: `1px solid ${colors.gray200}`,
  '&:last-child': {
    borderBottom: 'none',
  },
});

export const MobileFieldLabel = styled('div')({
  backgroundColor: colors.primary15,
  padding: '6px 12px',
  height: '32px',
  fontSize: '14px',
  color: colors.gray900,
  textAlign: 'center',
});

export const MobileComparisonRow = styled('div')({
  display: 'grid',
  gridTemplateColumns: '50% 50%',
  gridTemplateRows: 'auto 1fr',
  gap: '1px',
  backgroundColor: colors.gray200,
});

export const MobileComparisonHeader = styled('div')({
  backgroundColor: colors.primary50,
  padding: '3px 12px',
  height: '32px',
  fontSize: '14px',
  fontWeight: 600,
  color: colors.primary900,
  textAlign: 'center',
  gridRow: '1',
});

export const MobileComparisonValue = styled('div')({
  backgroundColor: colors.white,
  padding: '4px 12px',
  fontSize: '14px',
  color: colors.gray900,
  minHeight: '32px',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  wordWrap: 'break-word',
  textAlign: 'center',
  gridRow: '2',
  columnGap: '3px',
});
